import { E as u } from "./ProductBenefits-7967c295.js";

const _ = () => {
  const e = document.querySelector(".embla");
  
  // --- DÉBUT DE LA CORRECTION ---
  // Si l'élément .embla n'est pas trouvé, on arrête l'exécution de la fonction.
  if (!e) return;
  // --- FIN DE LA CORRECTION ---

  const o = u(e, {
    align: "center",
    loop: !1,
    breakpoints: { "(min-width: 64em)": { align: "start" } },
  });
  const l = e == null ? void 0 : e.querySelector(".embla__prev"),
    r = e == null ? void 0 : e.querySelector(".embla__next");
  l == null ||
    l.addEventListener("click", () => {
      o.scrollPrev();
    }),
    r == null ||
      r.addEventListener("click", () => {
        o.scrollNext();
      });
  const t = e == null ? void 0 : e.querySelector(".embla__dots"),
    a = t == null ? void 0 : t.querySelector(".embla__dot");
  let s = [];
  const d = () => {
      if (t) {
        for (; t.firstChild; ) t.removeChild(t.firstChild);
        a &&
          (s = o.scrollSnapList().map((p, n) => {
            const i = a.cloneNode(!0);
            return (
              t.appendChild(i),
              i.addEventListener(
                "click",
                () => {
                  o.scrollTo(n);
                },
                !1
              ),
              i
            );
          }));
      }
    },
    c = () => {
      if (!t) return;
      s = Array.from(t.querySelectorAll(".embla__dot"));
      const p = o.previousScrollSnap(),
        n = o.selectedScrollSnap();
      s[p].classList.remove("selected"), s[n].classList.add("selected");
    };
  o.on("init", d).on("reInit", d).on("init", c).on("reInit", c).on("select", c);
};
export { _ as A };